const Prefix = ({ children }) => (
  <div
    style={{
      marginLeft: 0,
      marginRight: 16,
      minWidth: 28,
    }}
  >
    {children}
  </div>
);
export default Prefix;
